import type { SalaPreparada } from './aplicativo';

/**
 * AS REGRAS DO "ENCERRAR SALA" (03/11/2026), sem rede e sem aparelho — testadas em `regrasDoEncerrar.test.ts`. O que elas
 * decidem e por quê está em `encerrarSala.ts`.
 */
/** A carência da sala preparada DEPOIS do prazo: a mesma do aparelho (`desktop/src/sala/limpeza.js`) e do servidor. */
const CARENCIA_DEPOIS_DO_PRAZO_DIAS = 7;
const DIA = 86_400_000;

export interface SalaNoPortal { id: number; simuladoId: number; titulo: string; prazo: string | null; status: 'DRAFT' | 'ACTIVE' | 'ENDED'; encerradaPor: string | null }
export interface ItemDaFila { id: number; userId: number; simuladoId: number; titulo: string; desde: string }

/** O que falta enviar desta sala, pelo que o aparelho diz. Nulo = o aparelho não diz (ponte anterior à 2.0.20). */
export function pendentesDe(sala: SalaPreparada): number | null {
  if (!sala.aEnviar) return null;
  return (sala.aEnviar.entregas ?? 0) + (sala.aEnviar.fotos ?? 0) + (sala.aEnviar.presenca ? 1 : 0);
}

/** O que a notícia leva de cada sala. Só as da conta (a de outro professor deste aparelho fica com ele). */
export function itensDaNoticia(salas: SalaPreparada[], userId: number) {
  return salas
    .filter((s) => s.professorId == null || Number(s.professorId) === Number(userId))
    .map((s) => ({ id: s.id, abertaAgora: !!s.abertaAgora, iniciadaEm: s.estado?.iniciadaEm ?? null, encerradaEm: s.estado?.encerradaEm ?? null, pendentes: s.aEnviar ? (s.aEnviar.entregas ?? 0) : null }));
}

export type ComoEncerrar = 'abrir' | 'enviar-antes' | 'encerrar';
export function comoEncerrar(sala: SalaPreparada): ComoEncerrar {
  if (sala.abertaAgora || (sala.estado?.iniciadaEm && !sala.estado?.encerradaEm)) return 'abrir';
  if ((pendentesDe(sala) ?? 0) > 0) return 'enviar-antes';
  return 'encerrar';
}

/**
 * As salas esquecidas, para o aviso do topo: da conta, ainda com a prova neste aparelho, não encerradas no portal, sem o
 * envio concluído aqui, e com o prazo do simulado vencido — a preparada depois do prazo, só depois da carência.
 */
export function salasEsquecidas(salas: SalaPreparada[], noPortal: SalaNoPortal[], userId: number, agora = Date.now()): Array<{ sala: SalaPreparada; titulo: string }> {
  const r: Array<{ sala: SalaPreparada; titulo: string }> = [];
  for (const s of salas) {
    if (s.pacoteApagadoEm || (s.professorId != null && Number(s.professorId) !== Number(userId))) continue;
    const p = noPortal.find((x) => x.id === s.id);
    if (!p || p.status === 'ENDED' || !p.prazo) continue;
    const enviada = !!s.estado?.encerradaEm && ['enviado', 'nada-a-enviar'].includes(String(s.estado?.envio?.situacao ?? ''));
    if (enviada) continue;
    const prazo = Date.parse(p.prazo), preparada = Date.parse(s.preparadaEm);
    if (!(prazo < agora)) continue;
    if (Number.isFinite(preparada) && preparada > prazo && agora - preparada < CARENCIA_DEPOIS_DO_PRAZO_DIAS * DIA) continue;
    r.push({ sala: s, titulo: p.titulo });
  }
  return r;
}
